// German
export default {
  newVersionAvailable: 'Neue Version verfügbar',
  versionInfo: 'Eine neue Version von {appName} ist verfügbar. Bitte laden Sie die Seite neu, um auf Version {version} zu aktualisieren.',
  reload: 'Neu laden',
  later: 'Später',
};
